<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
  <h3 class="text-center">Fonts</h3>
  <div class="row mb-4">
    <div class="col-md-4">
      <app-pagination-count
        [count]="fontsMaxCount"
        singularName="Font"
        pluralName="Fonts"
      ></app-pagination-count>
    </div>
    <div class="col-md-4 offset-md-4">
      <div class="input-group">
        <input name='search_term' type="text" class="form-control" placeholder="Name" (keyup)="setSearchTerm($event)" />
        <div class="input-group-append" (click)="searchFonts()">
          <button class="btn btn-outline-secondary" type="button"><i class="fas fa-search"></i></button>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div class="row mb-4">
    <div class="col-md-9">
      <table class="table">
        <thead>
          <tr>
            <td>S.No</td>
            <td>Name</td>
            <td>Types</td>
            <td>Delete</td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let font of fonts">
            <td>{{ font.id }}</td>
            <td>
              <a href="http://development.princelaw.com:4006/fonts/{{ font.id }}">{{ font.name }}</a>
            </td>
            <td>
              |
              <span *ngFor="let fontType of font.types"
                ><a href="http://development.princelaw.com:4006/fonts/{{ fontType[1] }}">{{ fontType[0] }}</a> |</span
              >
            </td>
            <td>
              <button type="button" class="btn btn-danger btn-sm" (click)="deleteFont(font.id, font)" [disabled]="font.isDeleting">
                {{ font.isDeleting ? 'Deleting' : 'Delete' }}<span *ngIf="font.isDeleting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Add Font</h5>
          <form #currentForm="ngForm" novalidate>
            <div class="form-group">
              <label for="font-name">Name</label>
              <input name='font_name' type="text" class="form-control" id="font-name" (change)="getFontUploadFormInputs($event, 'fontName')" />
            </div>
            <div class="form-group">
              <label for="regular"><p class="font-weight-bold">Font file - regular</p></label>
              <input name='upload_regular' type="file" class="form-control-file" id="regular" [uploader]="uploader" ng2FileSelect />
              <p class="text-muted">Select the associated font file</p>
            </div>
            <div class="form-group">
              <label for="bold"><p class="font-weight-bold">Font file - bold</p></label>
              <input name='upload_bold' type="file" class="form-control-file" id="bold" [uploader]="boldUploader" ng2FileSelect />
              <p class="text-muted">Select the associated font file</p>
            </div>
            <div class="form-group">
              <label for="italic"><p class="font-weight-bold">Font file - italic</p></label>
              <input name='upload_italic' type="file" class="form-control-file" id="italic" [uploader]="italicUploader" ng2FileSelect />
              <p class="text-muted">Select the associated font file</p>
            </div>
            <div class="form-group">
              <label for="bold-italic"><p class="font-weight-bold">Font file - bold and italic</p></label>
              <input name='upload_bold_italic' type="file" class="form-control-file" id="bold-italic" [uploader]="boldItalicUploader" ng2FileSelect />
              <p class="text-muted">Select the associated font file</p>
            </div>
            <div class="form-group">
              <label for="font-description"><p class="font-weight-bold">Description</p></label>
              <textarea name='font_description' class="form-control" id="font-description" rows="3" placeholder="Notes for purpose/usage of font - optional" (change)="getFontUploadFormInputs($event, 'fontDescription')"></textarea>
            </div>
            <div class="form-group form-check">
              <input name='is_default' ngDefaultControl type="checkbox" class="form-check-input" id="is-default" [(ngModel)]="isFontDefault" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
              <label class="form-check-label" for="is-default">Is default (overrides previous default font)</label>
            </div>
            <button type="button" class="btn btn-primary btn-sm" (click)="uploadFont(currentForm.form.valid)">Upload Font</button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <pagination
    (pageChanged)="loadFonts($event)"
    class="pagination-sm"
    [boundaryLinks]="true"
    [totalItems]="fontsMaxCount"
    [maxSize]="paginateParams.per_page"
    [(ngModel)]="paginateParams.page"
    [itemsPerPage]="paginateParams.per_page"
    previousText="&lsaquo;"
    nextText="&rsaquo;"
    firstText="&laquo;"
    lastText="&raquo;"
  ></pagination>
</div>
